// Follow-up agent and per-item skip choices.
window.PlummeI18n.register('no', {
  'ap.skip.title': 'Hopp over oppfølging',
  'ap.skip.nextMonth': 'Minn meg neste måned',
  'ap.skip.always': 'Ignorer dette punktet',
  'ap.skip.help': 'Utsett punktet til neste måned, eller ignorer akkurat dette punktet. Nye fakturaer, kunder og andre nye funn vil fortsatt vises.',
  'ap.skip.itemFallback': 'Dette oppfølgingspunktet',
  'ap.skip.all': 'Hopp over alle',
  'ap.skip.allInvoices': 'Alle dokumentene i denne listen',
  'ap.skip.allCustomers': 'Alle kundene i denne listen',
  'ap.agent.followup.title': 'Oppfølgingsagenten',
  'ap.agent.followup.detail': 'Fanger opp opplysninger og avvik som ikke tilhører en innleveringsagent.',
  'ap.permission.followup.label': 'Oppfølgingsagenten',
  'ap.permission.followup.desc': 'Fanger opp opplysninger, kundedialoger og avvik som ikke hører til en innleveringsagent.',
  'ap.lineIgnoredToast': 'Dette punktet er ignorert. Nye oppfølgingspunkter vil fortsatt vises.',
  'ap.linesSkippedToast': '{{count}} punkter er hoppet over.',
  'ap.followup.correctionOne': '{{count}} feil må korrigeres.',
  'ap.followup.correctionMany': '{{count}} feil må korrigeres.',
  'ap.followup.correctionDetailOne': '{{count}} punkt må korrigeres',
  'ap.followup.correctionDetailMany': '{{count}} punkter må korrigeres',
  'ap.followup.mustCorrect': 'Må korrigeres',
  'ap.followup.correct': 'Korriger',
  'ap.followup.correctInSettings': 'Korriger i innstillinger',
});
window.PlummeI18n.register('en', {
  'ap.skip.title': 'Skip follow-up',
  'ap.skip.nextMonth': 'Remind me next month',
  'ap.skip.always': 'Ignore this item',
  'ap.skip.help': 'Postpone the item until next month, or ignore this exact item. New invoices, customers and other findings will still appear.',
  'ap.skip.itemFallback': 'This follow-up item',
  'ap.skip.all': 'Skip all',
  'ap.skip.allInvoices': 'All documents in this list',
  'ap.skip.allCustomers': 'All customers in this list',
  'ap.agent.followup.title': 'Follow-up agent',
  'ap.agent.followup.detail': 'Catches information and discrepancies that do not belong to a filing agent.',
  'ap.permission.followup.label': 'Follow-up agent',
  'ap.permission.followup.desc': 'Catches information, customer conversations and discrepancies that do not belong to a filing agent.',
  'ap.lineIgnoredToast': 'This item is ignored. New follow-up items will still appear.',
  'ap.linesSkippedToast': '{{count}} items were skipped.',
  'ap.followup.correctionOne': '{{count}} error must be corrected.',
  'ap.followup.correctionMany': '{{count}} errors must be corrected.',
  'ap.followup.correctionDetailOne': '{{count}} item must be corrected',
  'ap.followup.correctionDetailMany': '{{count}} items must be corrected',
  'ap.followup.mustCorrect': 'Must be corrected',
  'ap.followup.correct': 'Correct',
  'ap.followup.correctInSettings': 'Correct in settings',
});
